module.exports = __webpack_public_path__ + "static/media/planradar.41a783f9.jpg";